import React from 'react';
import { TrendingUp, BarChart3, Shield, Cpu, Clock, Target } from 'lucide-react';

function About() {
  return (
    <div className="container">
      <div style={{ marginBottom: '30px' }}>
        <h1 style={{ fontSize: '1.8rem', fontWeight: '600', color: '#333', marginBottom: '8px' }}>
          About Trade Like an Institute
        </h1>
        <p style={{ color: '#667eea', fontSize: '0.95rem', fontStyle: 'italic' }}>
          "Institutional discipline, Individual freedom"
        </p>
      </div>

      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '30px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#333', marginBottom: '20px' }}>
          Overview
        </h2>
        <p style={{ fontSize: '1rem', color: '#666', lineHeight: '1.8', marginBottom: '15px' }}>
          Trade Like an Institute embodies the philosophy that successful trading isn't about winning every trade - 
          it's about having the discipline to cut losses small and let winners run. Our algorithmic system follows 
          institutional-grade risk management where losing battles is part of the strategy to win the war. 
          Our main goal is not to lose more than 1% of capital on any given day.
        </p>
        <p style={{ fontSize: '1rem', color: '#666', lineHeight: '1.8' }}>
          Just like institutional traders who accept that 30-40% of trades may be losses, our system focuses on 
          the bigger picture: consistent profitability over time through proper position sizing, strict stop-losses, 
          and the patience to wait for high-probability setups.
        </p>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
        gap: '20px',
        marginBottom: '30px'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '25px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Cpu size={24} color="white" />
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
              Technology Stack
            </h3>
          </div>
          <ul style={{ color: '#666', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Python-based trading engine</li>
            <li>Real-time data feed integration</li>
            <li>Multi-timeframe analysis</li>
            <li>REST APIs for broker connectivity</li>
            <li>Cloud-based infrastructure</li>
          </ul>
        </div>

        <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '25px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <BarChart3 size={24} color="white" />
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
              Trading Strategies
            </h3>
          </div>
          <ul style={{ color: '#666', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>No Indicators, nothing fancy</li>
            <li>Only Neutral Strategies</li>
            <li>Straddle, Iron Condor, Calender Spread.. etc</li>
            <li>Volume/Volatality/Open Interest based entry</li>
          </ul>
        </div>

        <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '25px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Shield size={24} color="white" />
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
              Risk Management
            </h3>
          </div>
          <ul style={{ color: '#666', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>Maximum loss per day is 1% of total capital</li>
            <li>Tight Stop Loss</li>
            <li>Only 1 trade per day</li>
            <li>No Adjustments if trade goes against you - EXIT</li>
          </ul>
        </div>

        <div style={{
          background: 'white',
          borderRadius: '8px',
          padding: '25px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '15px' }}>
            <div style={{
              width: '50px',
              height: '50px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Target size={24} color="white" />
            </div>
            <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333' }}>
              Performance Metrics
            </h3>
          </div>
          <ul style={{ color: '#666', lineHeight: '1.8', paddingLeft: '20px' }}>
            <li>80% Win rate achieved</li>
            <li>Maximum 1% loss per day</li>
            <li>We can scale this strategy to 100Cr without any slippage</li>
          </ul>
        </div>
      </div>

      <div style={{
        background: 'white',
        borderRadius: '8px',
        padding: '30px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '30px'
      }}>
        <h2 style={{ fontSize: '1.3rem', fontWeight: '600', color: '#333', marginBottom: '20px' }}>
          How It Works
        </h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '30px' }}>
          <div>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#667eea',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>1</div>
            <h4 style={{ color: '#333', marginBottom: '8px' }}>Market Scanning</h4>
            <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6' }}>
              Continuously scans NIFTY 50 for trading opportunities using multiple technical indicators.
            </p>
          </div>

          <div>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#667eea',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>2</div>
            <h4 style={{ color: '#333', marginBottom: '8px' }}>Signal Generation</h4>
            <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6' }}>
              When conditions match predefined criteria, the system generates buy/sell signals with calculated risk parameters.
            </p>
          </div>

          <div>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#667eea',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>3</div>
            <h4 style={{ color: '#333', marginBottom: '8px' }}>Order Execution</h4>
            <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6' }}>
              Orders are automatically placed with the broker with proper position sizing and stop-loss levels.
            </p>
          </div>

          <div>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: '#667eea',
              color: 'white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              marginBottom: '10px'
            }}>4</div>
            <h4 style={{ color: '#333', marginBottom: '8px' }}>Position Management</h4>
            <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6' }}>
              Monitors open positions, trails stop-losses, and exits based on target achievement or market conditions.
            </p>
          </div>
        </div>
      </div>

      <div style={{
        background: '#f8f9fa',
        borderRadius: '8px',
        padding: '30px',
        textAlign: 'center'
      }}>
        <h3 style={{ fontSize: '1.2rem', fontWeight: '600', color: '#333', marginBottom: '15px' }}>
          Disclaimer
        </h3>
        <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6' }}>
          Past performance is not indicative of future results. Algorithmic trading involves substantial risk of loss. 
          The system's performance is based on historical data and live trading results may vary. 
          All trading decisions are executed automatically based on predefined rules without human intervention.
        </p>
      </div>
    </div>
  );
}

export default About;